export const ACTIONS = {
    GET_ALL_PLAYLIST_SUCCESS: 'GET_ALL_PLAYLIST_SUCCESS',
    GET_ALL_PLAYLIST_FAILED: 'GET_ALL_PLAYLIST_FAILED',
    SEARCH_DATA: 'SEARCH_DATA',
    SELECT_VIDEOLIST: 'SELECT_VIDEOLIST',
    GET_CHANNEL_DETAILS_SUCCESS: 'GET_CHANNEL_DETAILS_SUCCESS',
    GET_CHANNEL_DETAILS_FAILURE: 'GET_CHANNEL_DETAILS_FAILURE'
}